import { PaymentConditionInput } from '../../lib/types/models/payment-condition/payment-condition-input'
import { Pcr } from '../../lib/types/models/pcr/pcr'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updatePaymentCondition(data: UpdateInput<PaymentConditionInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.paymentConditions.update.url, { id }))
    .patch<Pcr, Partial<PaymentConditionInput>>(rest)
}
